import { useQuery } from 'react-query';
import axios from 'axios';
import { StaticTokens, TerminalServicesAPI } from '../../constants/API';
import { OrderUnitsType } from '../../types/Terminal/TerminalTypes';

export const useGetOrderUnits = () => {
  const resolvedToken =
    typeof window !== 'undefined'
      ? new URLSearchParams(window.location.search).get('token') || StaticTokens.terminalToken
      : StaticTokens.terminalToken;
  const isTokenAvailable = !!resolvedToken;

  const {
    data: orderUnitsData,
    isLoading: isLoadingOrderUnitsData,
    isSuccess: isOrderUnitsDataReceived
  } = useQuery(
    ['getOrderUnitsInTerminal', resolvedToken],
    () =>
      axios.get<OrderUnitsType>(TerminalServicesAPI.getServices, {
        headers: {
          'X-API-TOKEN': resolvedToken
        }
      }),
    {
      select: ({ data }) => data,
      enabled: isTokenAvailable,
      refetchInterval: 4000,
      notifyOnChangeProps: ['data', 'error']
    }
  );

  return { orderUnitsData, isLoadingOrderUnitsData, isOrderUnitsDataReceived };
};
